<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)" [loading]="loading">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns"
        [ngStyle]="{'width': col.width ,'display': col.display}"
        [pSortableColumn]="col.field=='lab' ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field=='lab' ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td class="wrapword" [ngStyle]="{'display': col.display}"
          *ngIf="col.field == 'processFlowName' || col.field == 'sampleType' || col.field == 'beadChipSize' || col.field == 'aliqoutVolume' ">
          {{rowData[col.field]}}
        </td>
        <td class="wrapword" [ngStyle]="{'display': col.display}"
          *ngIf="col.field != 'lab' && col.field != 'processFlowName' && col.field != 'sampleType' && col.field != 'beadChipSize' ">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td class="wrapword" [ngStyle]="{'display': col.display}" *ngIf="col.field == 'lab' ">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div class="text-left">
      <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
    </div>
  </ng-template>
</p-table>


<p-dialog header="{{title}} Details" [(visible)]="displayMasterListDialog" [focusOnShow]="false" showEffect="fade" [contentStyle]="{'max-height':'80vh','overflow-y':'auto'}"
  [modal]="true" [dismissableMask]="true" position="top" maximizable="true" baseZIndex="10">
  <div *ngIf="masterList">
    <div>
      <label>Process Flow Name</label>
      <input pInputText class="form-control" [(ngModel)]="masterList['processFlowName']"
        (change)="masterList['processFlowName']=masterList['processFlowName'].trim()" [readonly]="disableProcessFlowNameField()">
    </div>
    <br>

    <div>
      <label>Lab</label>
      <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" [filter]="true" placeholder="Select a Lab"
        optionLabel="name" [showClear]="true"></p-dropdown>
    </div>
    <br>
    
    <div>
      <label>SampleType</label>
      <input pInputText class="form-control" [(ngModel)]="masterList['sampleType']"
        (change)="masterList['sampleType']=masterList['sampleType'].trim()">
    </div>
    <br>
    
    <div>
      <label>BeadChipSize</label>
      <input pInputText class="form-control" [(ngModel)]="masterList['beadChipSize']">
    </div>
    <br>
    
    <div>
      <label>Aliqout Volume</label>
      <input pInputText class="form-control" [(ngModel)]="masterList['aliqoutVolume']">
    </div>
    <br>
    
    <div>
      <label>Active</label>
      <p-checkbox [(ngModel)]="masterList['active']" binary="true"></p-checkbox>
    </div>
    
    <div>
      <label>Detailed Workflow</label>
      <p-checkbox [(ngModel)]="masterList['detailedWorkflow']" binary="true"></p-checkbox>
    </div>
    
    <p-accordion>
      <p-accordionTab header="Reception">
        <div *ngFor="let col of tableCols">
          <div *ngIf="col.group == 'Reception'">
            <label>{{col.header}}</label>
            <div class="form-group m-2">
              <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
            </div>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Preparation">
        <div *ngFor="let col of tableCols">
          <div *ngIf="col.group == 'Preparation'">
            <label>{{col.header}}</label>
            <div class="form-group">
              <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
            </div>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Sample Flow">
        <div *ngFor="let col of tableCols">
          <div *ngIf="col.group == 'SampleFlow'">
            <label>{{col.header}}</label>
            <div class="form-group">
              <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
            </div>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
  <br>
  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button style ="height: 32px;" type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterList()"
      label="Save" class="float-right"></button>
  </div>

</p-dialog>
